import { createContext } from 'react';

import type { TLeadMessagesPageContext } from 'src/pages/landlord/leads/messages/context/types';

// @ts-expect-error lateinit
export const LeadMessagesPageContext = createContext<TLeadMessagesPageContext>();